import React from 'react'
import styled from 'styled-components'
import Router from 'next/router'

import hk01LogoImageSrc from '/static/images/hk01-logo.png'
import CouponSvg from '/static/images/logo-coupon.svg'
import { openLinkBlank } from 'utils/appSchemeUtil'

const goHk01 = () => {
  openLinkBlank('https://www.hk01.com')
}
const goHome = () => {
  Router.push('/skus')
}
const Logo = () => (
  <>
    <Hk01LogoImage src={hk01LogoImageSrc} onClick={goHk01} />
    <Divider />
    <CouponImage onClick={goHome} />
  </>
)

const Hk01LogoImage = styled.img`
  width: 60px;
  height: 32px;
  cursor: pointer;
`

const CouponImage = styled(CouponSvg)`
  width: 64px;
  height: 30px;
  cursor: pointer;
  margin-right: 40px;
`

const Divider = styled.div`
  width: 1px;
  height: 32px;
  background-color: #000;
  margin: 0 16px;
`

export default Logo
